import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  BambooHrField,
  BambooHrIntegrationConfig
} from '@dadohr/shared/domainTypes/integrations/bamboohr';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toBambooHrSheetsConfigDoc = generateToDocFn<BambooHrIntegrationConfig>();

const COLLECTION = FS.bamboohrIntegrationConfig;
const collection = () => store().collection(COLLECTION);
export const bambooHrConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toBambooHrSheetsConfigDoc
);

export const useBambooHrConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(bambooHrConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<BambooHrIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            subdomain: '',
            apiKey: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeBambooHrConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getBambooHrFields = (orgId: string): Promise<BambooHrField[]> => {
  return callFirebaseFunction<BambooHrField[]>(
    'integrations_bamboohr-getFields',
    { orgId }
  ).catch((err) => {
    console.log('FAILED TO RETRIEVE BAMBOO FIELDS', err);
    return [];
  });
};
